import React from 'react';
import { Mail, Building2, ShieldCheck, CalendarDays } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import { getInitials } from '../lib/utils';

const Row = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-center gap-4 py-4 border-b border-zinc-800 last:border-0">
    <Icon className="h-4 w-4 text-zinc-500" />
    <span className="w-32 text-sm text-zinc-500">{label}</span>
    <span className="text-sm text-white" data-testid={testId}>{value || '—'}</span>
  </div>
);

export default function LearnerProfilePage() {
  const { user } = useAuth();
  const joined = user?.created_at ? new Date(user.created_at).toLocaleDateString() : null;
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="learner-profile-page">
        <div className="flex items-center gap-5 mb-10">
          <Avatar className="h-16 w-16 border border-zinc-700">
            <AvatarImage src={user?.picture} alt={user?.full_name} />
            <AvatarFallback className="bg-navigate-surface text-navigate-gold">{getInitials(user?.full_name)}</AvatarFallback>
          </Avatar>
          <div>
            <h1 className="font-heading text-3xl font-bold text-white" data-testid="profile-name">{user?.full_name}</h1>
            <p className="text-zinc-400 text-sm">Your profile</p>
          </div>
        </div>
        <Card className="bg-zinc-900 border-zinc-800">
          <CardContent className="py-2">
            <Row icon={Mail} label="Email" value={user?.email} testId="profile-email" />
            <Row icon={ShieldCheck} label="Role" value={user?.role ? user.role.replace('_', ' ') : null} testId="profile-role" />
            <Row icon={Building2} label="Organisation" value={user?.organization_name || user?.company} testId="profile-organisation" />
            <Row icon={CalendarDays} label="Member since" value={joined} testId="profile-joined" />
          </CardContent>
        </Card>
        <p className="text-xs text-zinc-500 mt-4">To update your details, please contact your administrator.</p>
      </div>
    </Layout>
  );
}
